import { useState, useEffect } from "react";

import Spinner from "../../spinners/DataSpinner";

import axios from "axios";

import { Link, useNavigate, useParams } from "react-router-dom";

import swal from "sweetalert";

import './ProductDetailsStyles.css';

const ProductDetails = () => {

    const navigate = useNavigate();

    const { category } = useParams();
    const { product } = useParams();

    const [loading, setLoading] = useState(true);
    const [productDetails, setProductDetails] = useState([]);

    const [quantity, setQuantity] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {

        let isMounted = true;

        axios.get(`api/get-product-details/${category}/${product}`)
            .then(res => {
                if (isMounted) {
                    if (res.data.status === 200) {
                        setProductDetails(res.data.product);
                        setLoading(false);
                    }
                } else if (res.data.status === 400) {
                    swal("Warning", res.data.message, "error");
                    navigate("/collections");
                }
            });

        return () => {
            isMounted = false;
        }

    }, [category, product]);

    const handleQuantity = (e, type) => {
        if (type == "inc") {
            if (quantity < 10) {
                setQuantity((prevCount) => prevCount + 1);
            }
        } else if (type == "dec") {
            if (quantity > 1) {
                setQuantity((prevCount) => prevCount - 1);
            }
        }
    }

    const handleAddToCart = (e) => {
        
        e.preventDefault();

        const formData = {
            product_id: productDetails.id,
            product_qty: quantity,
        }

        setIsSubmitting(true);

        axios.post(`api/add-to-cart`, formData)
            .then(res => {
                if (res.data.status === 201) {
                    swal('Success', res.data.message, "success");
                } else if (res.data.status === 409) {
                    swal('Warning', res.data.message, "warning");
                } else if (res.data.status === 401) {
                    swal('Error', res.data.message, "error");
                } else if (res.data.status === 404) {
                    swal('Warning', res.data.message, "warning");
                }

                setIsSubmitting(false);
                
            });
    }

    if (loading) {
        return <Spinner />
    } else {
        var isInStock = "";
        if (productDetails.qty > 0) {
            isInStock =
                <>
                    <div className="product_quantity position-relative">
                        <span>QTY: </span>
                        <span id="quantity_input">{quantity}</span>
                        <div className="quantity_buttons">
                            <div id="quantity_inc_button" className="quantity_inc quantity_control" onClick={(e) => handleQuantity(e, 'inc')}>
                                <i className="fas fa-chevron-up"></i>
                            </div>
                            <div id="quantity_dec_button" className="quantity_dec quantity_control" onClick={(e) => handleQuantity(e, 'dec')}>
                                <i className="fas fa-chevron-down"></i>
                            </div>
                        </div>
                    </div>

                    <div className="cart mt-4 mb-4 align-items-center">
                        <button className="btn btn-danger text-uppercase mr-2 px-4" onClick={handleAddToCart} disabled={isSubmitting}>
                            {isSubmitting && (
                                <span className="spinner-grow spinner-grow-sm mr-2"></span>
                            )}
                            Add to cart
                        </button>
                        <span>In Stock</span>
                    </div>
                </>
        } else {
            isInStock = <span className="alert alert-danger mt-2 d-inline-block">The Product Is out of Stock</span>
        }
    }

    return (
        <div className="album py-3 bg-light">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <Link to='/collections'>Collections</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <Link to={`/collections/${category}`}>Category</Link>
                        </li>
                        <li className="breadcrumb-item">
                            {productDetails.category.name}
                        </li>
                    </ol>
                </nav>
                <div className="row d-flex justify-content-center">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="images p-3">
                                        <div className="text-center p-4">
                                            <img className="img-fluid" id="main-image" src={`${process.env.REACT_APP_API_URL}/public/uploads/products/${productDetails.image}`} alt={productDetails.name} />
                                        </div>
                                        <div className="thumbnail text-center">
                                            <img src={`${process.env.REACT_APP_API_URL}/public/uploads/products/${productDetails.image}`} width="70" alt={productDetails.name} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="product p-4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa fa-long-arrow-left"></i>
                                                <span className="ml-1">{productDetails.brand}</span>
                                            </div>
                                            <i className="fa fa-shopping-cart text-muted"></i>
                                        </div>
                                        <div className="mt-4 mb-3">
                                            <span className="text-uppercase text-muted brand">{productDetails.category.name}</span>
                                            <h5 className="text-uppercase">{productDetails.name}</h5>
                                            <div className="price d-flex flex-row align-items-center">
                                                <span className="act-price">{productDetails.sale_price}$</span>
                                                <span className="act-price ml-2"><del>{productDetails.original_price}$</del></span>
                                            </div>
                                        </div>
                                        <p className="about">
                                            {productDetails.description}
                                        </p>

                                        {isInStock}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductDetails;